<template>
  <div class="web-box-all">
    <ext-header select_menu="9"></ext-header>

    <div class="web-home-main">

      <div class="web-order-box">
        <div class="web-order-left">
          <ext-nav></ext-nav>
        </div>
        <div class="web-order-right">

          <div class="web-order-title">
            <ul>
              <li class="select">
                <a>意见反馈</a>
              </li>
            </ul>
          </div>

          <div class="web-store-info">
            <ul>
              <li>
                <a>反馈类型：</a>
                <div class="web-feedback-input">
                  <b-form-select v-model="feedback_class" :options="options" disabled-field="请选择反馈类型" class="mt-3"></b-form-select>
                </div>
              </li>
              <li>
                <a>反馈内容：</a>
                <div class="web-feedback-input">
                  <b-form-textarea
                    size="sm"
                    v-model="feedback_remark"
                    placeholder="请描述您遇到的问题 ，不少于15字"
                  ></b-form-textarea>
                </div>
              </li>
              <li>
                <a>联系电话：</a>
                <div class="web-feedback-input">
                  <b-form-input v-model="feedback_phone" size="sm" placeholder="请填写您的联系电话"></b-form-input>
                </div>
              </li>
            </ul>

            <div class="web-order-info-image">
                <h2>凭证图片：</h2>
                <ul>
                  <li v-if="image_list.length<6">
                    <img @click="add_image()" src="@/assets/add_2icon.png"/>
                    <div style="width:1px;height:1px;  overflow: hidden; ">
                      <form id="fileForm" enctype="multipart/form-data" class="form-horizontal " >
                        <input id="get_upload" class="form-control" type="file" name="file" @change="handleFileChange">
                      </form>
                    </div>
                  </li>
                  <li v-for="(vo,index) in image_list" :key="index">
                    <img src="@/assets/goods_load.png" v-real-img="web_url+vo.img"/>
                    <a>
                      <img style="display:none;" src="@/assets/icon/img_1.png" @click="img_show(index,vo.img)"/>
                      <img src="@/assets/icon/img_2.png" @click="img_del(index)" />
                    </a>
                  </li>
                </ul>
            </div>
            <ul>
              <li>
                <a></a>
                <p>
                  <a id="post_data" @click="post_data()">确认提交</a>
                </p>
              </li>
            </ul>
          </div>

        </div>
      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import ExtNav from '@/components/leftnav/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl, upload} from '@/utils/extend'
import $ from 'jquery'
import Toast from '@/components/toast/index'

export default {
  name: 'feedback',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-nav': ExtNav,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '意见反馈',
      web_url: webUrl(),
      feedback_class: '',
      feedback_remark: '',
      feedback_phone: '',
      options: [],
      image_list: [],
      up_return_state: true,
      toast_state: 'display:none',
      toast_text: ''
    }
  },
  mounted () {
    this.load_data()
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 2000)
    },
    add_image () {
      $('#get_upload').trigger('click')
    },
    img_show (index, img) {

    },
    img_del (index) {
      this.image_list.splice(index, 1)
    },
    handleFileChange (e) {
      var vm = this
      let file = e.target.files[0]
      let supportedTypes = ['image/jpg', 'image/jpeg', 'image/png']
      if (file && supportedTypes.indexOf(file.type) >= 0) {
        const param = new FormData()
        param.append('uid', getUserId())
        param.append('file', file)

        upload({
          url: '/store/upload/file_upload',
          method: 'post',
          data: param
        }, function (ret) {
          if (ret && ret.code === 'success') {
            vm.toast(ret.msg)
            var getList = vm.image_list
            getList.push({
              img: ret.data.url
            })
            vm.image_list = getList
          } else {
            vm.toast(ret.msg)
          }
        })
      } else {
        vm.toast('文件格式只支持：jpg、jpeg 和 png')
      }
    },
    load_data () {
      var that = this
      ajax({
        url: '/store/user/load_feedback_class',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          var ListArr = []
          var list = ret.data

          list.forEach(function (val) {
            ListArr.push({
              'value': val,
              'text': val
            })
          })
          that.options = ListArr
          that.feedback_class = list['0']
        }
      })
    },
    verify_post (type) {
      if (type === true) {
        $('#post_data').css({'background': '#cccccc'})
      } else {
        $('#post_data').css({'background': '#d81e06'})
      }
    },
    post_data () {
      var that = this
      var feedbackClass = this.feedback_class
      var feedbackRemark = this.feedback_remark
      var feedbackPhone = this.feedback_phone
      var imgList = this.image_list

      that.verify_post(true)

      if (that.up_return_state === true) {
        that.up_return_state = false
        ajax({
          url: '/store/user/post_feedback',
          method: 'post',
          data: {
            uid: getUserId(),
            feedback_class: feedbackClass,
            feedback_remark: feedbackRemark,
            feedback_phone: feedbackPhone,
            img_1: imgList[0] ? imgList[0].img : '',
            img_2: imgList[1] ? imgList[1].img : '',
            img_3: imgList[2] ? imgList[2].img : '',
            img_4: imgList[3] ? imgList[3].img : '',
            img_5: imgList[4] ? imgList[4].img : '',
            img_6: imgList[5] ? imgList[5].img : ''
          }
        }, function (ret) {
          that.verify_post(false)
          if (ret && ret.code === 'success') {
            that.toast(ret.msg)
            setTimeout(function () {
              that.up_return_state = true
              that.$router.push({path: '/store/store_info', query: {}})
            }, 500)
          } else {
            that.up_return_state = true
            that.toast(ret.msg)
          }
        })
      }
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-box { width:100%; height:auto; flex-flow:row; align-content:flex-start; margin-top:20px;}
  .web-order-left { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; align-content:flex-start;}

  .web-order-right { width:785px; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-user-title { width:100%; height:40px;flex-flow:row; align-content:flex-start;}
      .web-user-title p { width:auto; height:40px; position: relative; padding:0px 20px; line-height:40px; font-size:14px; color:#333333;}
      .web-user-title p i { width:2px; height:20px; float: left; background: #d81e06; position: absolute; top:10px; left:10px;}
    .web-order-title { width:100%; height:50px; border-bottom: 1px solid #dfdfdf;}
      .web-order-title ul { width:400px; height:50px; list-style:none; margin:0px; padding:0px; flex-wrap:wrap; align-content:flex-start;}
      .web-order-title ul li { width:80px; height:50px; cursor: pointer; line-height: 50px; font-size:14px; text-align: center;justify-content:center; }
      .web-order-title ul li a { color:#333333;}
      .web-order-title ul li a:hover { color:#d81e06; font-weight: bold;}
      .web-order-title ul li.select { border-bottom: 2px solid #d81e06;}

   .web-store-info { width:100%; min-height: 402px; flex-wrap:wrap; margin-top:15px; border:1px  solid #dfdfdf; align-content:flex-start;}
      .web-store-info ul { width:100%; height: auto; list-style:none; margin-top:15px; flex-wrap:wrap; align-content:flex-start;}
      .web-store-info ul li { width:100%; height:auto; flex-flow:row; align-content:flex-start;}
      .web-store-info ul li a { width:80px; height:50px; line-height:50px; font-size:14px; color:#333333;}
      .web-store-info ul li p { width:auto; height:50px; line-height:50px; font-size:12px; color:#333333;}
      .web-store-info ul li p a { width:200px; height:40px; line-height:40px; cursor: pointer; margin-top:20px; border:4px; font-size:16px; color:#ffffff; background: #d81e06; justify-content: center;}
      .web-store-info ul li p a:hover { color:#ffffff;}
      .web-feedback-input { width:500px; height:auto; margin:0px; padding:0px;}
      .web-feedback-input select { margin:0px !important; margin-top:14px !important;}
      .web-feedback-input textarea { margin:0px !important; margin-top:14px !important;}
      .web-feedback-input input { margin:0px !important; margin-top:10px !important;}

.web-order-info-image { width:100%; height:auto; padding-left:30px; flex-wrap:wrap; align-content:flex-start;}
    .web-order-info-image h2 { width:77px; height:30px; line-height:30px; font-size:14px; margin:0px; padding:0px; color:#333333;}
    .web-order-info-image p { width:100%; height:30px; line-height:30px; font-size:14px; }
    .web-order-info-image p div.custom-radio { cursor: pointer;}
    .web-order-info-image h2 span { font-size:12px; color:#666666; font-weight: normal; margin-left:20px;}
    .web-order-info-image ul { width:600px; height:250px; margin:0px; padding:0px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap; list-style: none;}
    .web-order-info-image ul li { width:120px; height:120px; overflow: hidden; position: relative; border:1px solid #dfdfdf; overflow: hidden; margin:5px; cursor: pointer;}
    .web-order-info-image ul li img { width:120px; height:120px; object-fit: cover;}
    .web-order-info-image ul li a { width:120px; height:120px; position: relative; padding:45px 0px;justify-content:center; position: absolute; left:0px; top:0px; background: rgba(0,0,0,0.5);}
    .web-order-info-image ul li a img { width:30px; height:30px; margin:0px 5px;}
    .web-order-info-image ul li:hover { position: relative;}

</style>



// WEBPACK FOOTER //
// src/pages/store/feedback.vue